import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/"
)({
  component: () => (
    <Navigate
      to="/finance/donations/$tabKey"
      params={{ tabKey: "donations" }}
    />
  ),
})
